var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencilEdit = function SvgPencilEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 18v-7h-2v7H2V2h7V0H2a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h16a2 2 0 0 0 2-2ZM17.18.72a2.45 2.45 0 0 0-3.48 0L5.33 9.1A4.05 4.05 0 0 0 4 11.8V16h4.13a4.05 4.05 0 0 0 2.83-1.38l8.32-8.31a2.46 2.46 0 0 0 0-3.49l-2.1-2.1ZM8.06 14a2.08 2.08 0 0 0 1.43-.74l6.07-6.06-2.76-2.75-6.1 6.1c-.4.36-.66.86-.7 1.32V14h2.06Zm6.16-10.97 2.75 2.76.9-.9a.46.46 0 0 0 0-.65l-2.1-2.1a.46.46 0 0 0-.66 0l-.9.9Z",
    clipRule: "evenodd"
  })));
};
export default SvgPencilEdit;